import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { OffsetPaginated } from 'types/pagination';
import { Stream } from 'types/stream';

import { useStreams, UseStreamsParams } from './useStreams';

export function useOutputStreams(
  params?: UseStreamsParams,
  options?: UseQueryOptions<OffsetPaginated<Stream>, APIError>
) {
  return useStreams({
    params: {
      stream_types: ['rtsp', 'webrtc'],
      sources: ['camera_stream', 'pipeline_stream'],
      ...params,
    },
    ...options,
  });
}
